import script from "./Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Users.vue?vue&type=script&setup=true&lang=js"

import "./Users.vue?vue&type=style&index=0&id=bedc550c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bedc550c"]])

export default __exports__